import { Content } from 'components/common'
import { React, styled, mq } from 'x'

const Container = styled.div`
  max-width: 100%;
  overflow: hidden;
  position: relative;
  padding: 30px 0 0;
`

const Text = styled.div`
  margin-top: 0;
  margin-bottom: 0;
  color: ${(props) => props.theme.primary};

  blockquote {
    margin: 0;

    > h1, h2, h3, h4 {
      color: #2a2d58;
    }

    h1 {
      font-weight: 700;
      font-size: 50px;
      line-height: 60px;
    }

    > h2 {
      margin: 10px 0 30px;
      font-size: 24px;
      line-height: 34px;
    } 
     
    > p {
      color: ${(props) => props.theme.primary};
      line-height: 2;
      > strong {
        margin-bottom: 30px;
      }
      > img {
        margin: 19px 0;
      }
    }
  }

  .CTA-BTN {
    display: inline-block;
    margin: 30px 0 15px;
    color: #fff;
    font-weight: 600;
    text-decoration: none;
    line-height: 38px;
    letter-spacing: 1.2px;
    padding: 10px 20px;
    background-color: #f1b860;
    text-transform: uppercase;
  }

  > p {
    color: ${(props) => props.theme.primary};
    line-height: 2;
    > strong {
      margin-bottom: 30px;
    }
    > img {
      margin: 19px 0;
    }
  }

  > h1, h2, h3, h4 {
    color: #2a2d58;
  }

  h1 {
    font-weight: 700;
    font-size: 50px;
    line-height: 60px;
  }

  > h2 {
    margin: 10px 0 30px;
    font-size: 24px;
    line-height: 34px;
  } 

  h3 {
    margin: 18px 0;
  }

  ul, ol {
    margin: 30px auto 40px;

    > li {
      padding-left: 0px;
      margin-bottom: 15px;
      position: relative;
      color: ${(props) => props.theme.primary};
      line-height: 2;
    }
  }

  > ul 
    padding: 0;
    margin-bottom: 50px;
    max-width: 800px;
    margin: 60px auto;
    width: 100%;
    position: relative;
    list-style: none;

    > li {
      padding-left: 20px;
      margin-bottom: 15px;      
      &::before {
        position: absolute;
        content: '›';
        font-size: 12px;
        left: 0;
        top: 0;
        line-height: 33px;
      }

    }
  }

  img {
    max-width: 100%;
    height: auto;
  }

  > a {
    font-weight: bold;
  }
`

const RawHTML = (props) => {
  return (
    <Container>
      <Content>
        {props.data.content && (
          <Text
            dangerouslySetInnerHTML={{
              __html: props.data.content,
            }}
          ></Text>
        )}
      </Content>
    </Container>
  )
}

export default RawHTML
